// extracted by mini-css-extract-plugin
export default {"breadcrumb":"breadcrumb--72dcff9","nextCategory":"nextCategory--b83a59c"};